export default __webpack_public_path__ + "assets/images/da5e854ba085a13d6ad44dd53336781e.svg";